import {
    Box,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TableRow,
    TableSortLabel,
    Pagination,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import { BiSortAlt2 } from "react-icons/bi";
import { useEffect } from "react";
import TableNoItemComponent from "../../customComponent/TableNoItemComponent";

function ContactTable({ data, columns, pageNumber = 1 }) {
    useEffect(() => {
        if (pageNumber > 10) {
            setRowsPerPage(pageNumber);
        } else {
            setRowsPerPage(10);
        }
    }, [pageNumber]);

    const [selectedRows, setSelectedRows] = useState([]);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // Sort icon
    const CustomSortIcon = ({ direction }) => {
        return direction === "asc" ? (
            <img
                src="/menuIcons/tableUpSort.png"
                className="customIcon"
                alt="gsl"
                style={{ padding: "15px" }}
            />
        ) : (
            <BiSortAlt2 className="customIcon" />
        );
    };

    // sorting table
    const [sortBy, setSortBy] = useState(""); // Current sort column
    const [sortOrder, setSortOrder] = useState("asc"); // Current sort order

    const requestSort = (column) => {
        let newSortOrder = "asc";

        if (column === sortBy && sortOrder === "asc") {
            newSortOrder = "desc";
        }

        setSortBy(column);
        setSortOrder(newSortOrder);
    };

    let sortedData = useMemo(() => {
        setPage(1);
        if (sortBy && data) {
            const sortedItems = [...data].sort((a, b) => {
                if (sortOrder === "asc") {
                    return a[sortBy] < b[sortBy] ? -1 : 1;
                } else {
                    return a[sortBy] < b[sortBy] ? 1 : -1;
                }
            });

            return sortedItems;
        }

        return data;
    }, [data, sortBy, sortOrder]);

    // Create a function to handle selecting individual rows:
    const handleSelectRow = (rowId) => {
        let updatedSelectedRows;
        if (selectedRows.includes(rowId)) {
            updatedSelectedRows = selectedRows.filter((id) => id !== rowId);
            setSelectedRows(selectedRows.filter((id) => id !== rowId));
        } else {
            updatedSelectedRows = [...selectedRows, rowId];
            setSelectedRows(updatedSelectedRows);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const formateDate = (dateString) => {
        const dateObject = new Date(dateString);

        const formattedDate = `${dateObject.getDate()}/${dateObject.getMonth() + 1
            }/${dateObject.getFullYear()}`;

        return formattedDate;
    };

    return sortedData?.length === 0 ? (
        <TableNoItemComponent />
    ) : (
        <>
            <Box>
                <Box
                    sx={{
                        overflowX: "scroll",
                    }}
                >
                    <Table
                        className="masterTable"
                        sx={{
                            minWidth: "1000px",
                            width: "100%",
                        }}
                    >
                        <TableHead
                            sx={{
                                background: "#F9F9FB",
                            }}
                        >
                            <TableRow className="msterTableCell">
                                <TableCell>
                                    <Checkbox
                                        checked={selectedRows?.length === sortedData?.length}
                                        style={{ color: "#f81b82" }}
                                    />
                                </TableCell>
                                {columns?.map((column) => {
                                    if (column.hidden) {
                                        return null;
                                    }
                                    return (
                                        <TableCell key={column.field}>
                                            <TableSortLabel
                                                className="headerText"
                                                active={column === sortBy}
                                                direction={sortOrder}
                                                onClick={() => requestSort(column)}
                                                IconComponent={
                                                    column.field !== "action" && CustomSortIcon
                                                }
                                            >
                                                {column.title}
                                            </TableSortLabel>
                                        </TableCell>
                                    );
                                })}
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sortedData
                                ?.slice(
                                    (page - 1) * rowsPerPage,
                                    (page - 1) * rowsPerPage + rowsPerPage,
                                )
                                .map((item, indx) => (
                                    <TableRow className="tableRow" key={indx}>
                                        {/* Checkbox column */}
                                        <TableCell sx={{ width: "60px", minWidth: "60px" }}>
                                            <Checkbox
                                                checked={selectedRows.includes(item?.id)}
                                                onChange={() => handleSelectRow(item?.id)}
                                                style={{ color: "#f81b82" }}
                                            />
                                        </TableCell>

                                        {/* Index column */}
                                        <TableCell sx={{ width: "50px", minWidth: "50px" }}>
                                            {indx + 1}
                                        </TableCell>

                                        {/* Date column */}
                                        <TableCell sx={{ width: "150px", minWidth: "150px" }}>
                                            {formateDate(item?.createdAt)}
                                        </TableCell>

                                        {/* Name column */}
                                        <TableCell sx={{ width: "200px", minWidth: "200px" }}>
                                            {item?.leadName}
                                        </TableCell>

                                        {/* Email column */}
                                        <TableCell sx={{
                                            width: "250px",
                                            minWidth: "250px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}>
                                            {item?.email}
                                        </TableCell>

                                        {/* Phone column */}
                                        <TableCell sx={{ width: "150px", minWidth: "150px" }}>
                                            {item?.phoneNumber}
                                        </TableCell>

                                        {/* Message column */}
                                        <TableCell sx={{
                                            minWidth: "300px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        }}>
                                            {item?.message}
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                        <TableFooter />
                    </Table>
                </Box>
                <Pagination
                    sx={{
                        mt: "28px",
                        "& .Mui-selected": {
                            backgroundColor: "#f81b82 !important",
                            color: "#fff",
                        },
                        "& .MuiPagination-ul": {
                            justifyContent: "end",
                        },
                    }}
                    count={Math.ceil(data?.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                />
            </Box>
        </>
    );
}

export default ContactTable;
